// Reception's shared Supabase client (restaurant/data lives two levels below src/).
import { supabase } from '../../supabase.js';
import { SupabaseMenuStore } from './supabaseMenuStore.js';
import type { MenuStore } from './menuStore.js';

// Composition root for the menu data layer: the one place the Supabase client is
// bound to the MenuStore port. Production uses SupabaseMenuStore; tests call
// setMenuStore() to inject a fake (pipeline-tdd-ioc §7 — factory/module injection).
let active: MenuStore = new SupabaseMenuStore(supabase);

export function getMenuStore(): MenuStore {
  return active;
}

/** Override the active store — for tests, or an alternative backend. */
export function setMenuStore(store: MenuStore): void {
  active = store;
}
